var FAQ = (function() {
  function disableLinks() {
    const nav = document.querySelector(".b-faq__nav");
    nav.querySelectorAll("a").forEach(function(link) {
      link.classList.remove("is-active");
    });
  }

  function init() {
    const nav = document.querySelector(".b-faq__nav");

    nav.querySelectorAll("a").forEach(function(link) {
      const label = link.dataset.label;

      link.addEventListener("click", function(e) {
        e.preventDefault();
        disableLinks();
        this.classList.add("is-active");

        if (label === "clients") {
          document
            .querySelector(".b-faq__questions--clients")
            .classList.add("is-active");
          document
            .querySelector(".b-faq__questions--employees")
            .classList.remove("is-active");
        }
        if (label === "employees") {
          document
            .querySelector(".b-faq__questions--employees")
            .classList.add("is-active");
          document
            .querySelector(".b-faq__questions--clients")
            .classList.remove("is-active");
        }
      });
    });

    const questions = document.querySelectorAll(".b-faq__question");

    questions.forEach(function(question) {
      question.addEventListener("click", function() {
        if (question.classList.contains("is-active")) {
          question.classList.remove("is-active");
        } else {
          question.classList.add("is-active");
        }
      });
    });
  }

  return {
    init: init,
  };
})();
